import { API_PREFIX } from '@matchroom/shared';
import { env } from './env';

export const apiConfig = {
  baseUrl: env.VITE_API_URL,
  prefix: API_PREFIX,
  get fullBaseUrl() {
    return `${this.baseUrl}${this.prefix}`;
  },
} as const;

export const socketConfig = {
  url: env.VITE_SOCKET_URL,
  options: {
    autoConnect: false,
    transports: ['websocket', 'polling'] as ('websocket' | 'polling')[],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  },
} as const;

export const appConfig = {
  name: env.VITE_APP_NAME,
  tagline: env.VITE_APP_TAGLINE,
  version: env.VITE_APP_VERSION,
} as const;

export const queryConfig = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
  retry: 1,
} as const;

export const motionConfig = {
  page: {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -12 },
    transition: { duration: 0.3, ease: 'easeOut' },
  },
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.2 },
  },
  slideUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] },
  },
} as const;
